// extracted by mini-css-extract-plugin
export default {"floating_bottom_container":"floating_bottom_container__e3685fb9","floating_part":"floating_part__e3685fb9"};